$( document ).ready(function() {
  $(".custom_right").click(function(){
    var count = 0;
    $( ".product-thumbnails__items li button" ).each(function( index ) {
      if($(this).hasClass('active') && count == 0){
        count = parseInt($(this).attr('data-index')) + 1;
      }
      if(parseInt(count) >= 2){
        $('.custom_left').removeClass('slide_dis');
      }
      if(count != 0){
        if(parseInt($(this).attr('data-index')) == parseInt(count)){
          $(this).trigger('click');
          if($(this).hasClass('sld_last')){
            $('.custom_right').addClass('slide_dis');
          }  
        }
      }
    });
  });

   $(".custom_left").click(function(){
    var count = 0;
    $($(".product-thumbnails__items li button").get().reverse()).each(function( index ) {
      console.log($(this).attr('data-index'));
      if($(this).hasClass('active') && count == 0){
        count = parseInt($(this).attr('data-index')) - 1;
      }
      if(count != 0){
        if(parseInt($(this).attr('data-index')) == parseInt(count)){
          $(this).trigger('click');
          $('.custom_right').removeClass('slide_dis');
          if($(this).hasClass('sld_first')){
            $('.custom_left').addClass('slide_dis');
          }  
        }
      }
    });
  });

  
});